import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <ScrollManager />
      <Navbar />
      <main className="pt-20 md:pt-28">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
